import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@repo/contracts/marketplace/offers/enums';
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { CTASearchParams } from '@repo/platform-analytics/lib/ctaSearchParams';
import { CdnImage, IMAGE_SIZES } from '@repo/ui/primitives/CdnImage';
import { getContentProps } from '../lib/utils';
import type { CtaAnalyticsProps } from '../model/types';
import { CtaLink } from './CTA/CtaLink';
import { imageApplyNowLink } from './styles';
export type ImageApplyNowProps = {
  creditCardOffer: Offer;
  ctaAnalytics: CtaAnalyticsProps;
  src: string;
  shouldPrioritizeImage?: boolean;
};
export const ImageApplyNow = t0 => {
  const $ = _c(21);
  const {
    creditCardOffer,
    ctaAnalytics,
    src,
    shouldPrioritizeImage: t1
  } = t0;
  const shouldPrioritizeImage = t1 === undefined ? false : t1;
  const {
    name,
    cta
  } = creditCardOffer;
  let t2;
  if ($[0] !== creditCardOffer) {
    t2 = getContentProps(creditCardOffer);
    $[0] = creditCardOffer;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isReview,
    destinationURL
  } = t2;
  let t3;
  if ($[2] !== ctaAnalytics) {
    t3 = {
      ...ctaAnalytics,
      linkType: "PRODUCT_IMAGE"
    };
    $[2] = ctaAnalytics;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  const t5 = isReview ? "_self" : "_blank";
  const t6 = isReview ? "Review Link" : "Apply Now Link";
  let t7;
  if ($[4] !== isReview) {
    t7 = isReview ? [] : [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH];
    $[4] = isReview;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = `${name} card image`;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      objectFit: "contain"
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== shouldPrioritizeImage || $[8] !== src || $[9] !== t8) {
    t10 = <CdnImage fill={true} src={src} alt={t8} sizes={IMAGE_SIZES.PRODUCT_CARD} priority={shouldPrioritizeImage} style={t9} />;
    $[7] = shouldPrioritizeImage;
    $[8] = src;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== ctaAnalytics.finishType || $[12] !== destinationURL || $[13] !== isReview || $[14] !== t10 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t11 = <CtaLink finishType={ctaAnalytics.finishType} analytics={t3} type="PRODUCT_IMAGE" href={destinationURL} rel={t4} target={t5} aria-label={t6} isReview={isReview} parameterActions={t7} className={imageApplyNowLink}>{t10}</CtaLink>;
    $[11] = ctaAnalytics.finishType;
    $[12] = destinationURL;
    $[13] = isReview;
    $[14] = t10;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};